<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <meta name="author" content="Softnio" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />

      <!-- Fav Icon  -->

      <!-- Site Title  -->

      <!-- Vendor Bundle CSS -->
    </head>

  <body class="page-ath">
   
      <div class="page-ath-wrap">
         <div style="" class="page-ath-content">
          <div
            style="margin-bottom:0;padding-bottom:0;top:0"
            class="page-ath-header mt-0"
          >
            <span
              style="cursor:pointer;"
              @click.prevent="$router.go('/login')"
              class=""
            >
              <img src="../assets/bdt.png" alt="logo" />
             
            </span>
             <!-- <h4 style="text-align:center" class="">(Ropsten testnet version)</h4> -->
            <div v-if="isImport==false && create==false">
            <p
              style="text-align:center;color:grey"
              class="text-uppercase headline font-weight-normal    mt-5"
            >
              One decntralized kyc for all of our partners
            </p>

            <p
              style="text-align:center;color:grey"
              class=" mt-3"
            >
              Save your Time and Protect your personal data
            </p>
            <p
              style="text-align:center;color:grey"
              class="mt-3"
            >
              We give you the power to use your KYC for all of our Partners.
              Buy, store or exchange your Crypto and Fiat with one KYC. Share
              your digital ID anytime and anywhere.
            </p>
            <!-- <p style="text-align:center;" class="my-3 header ">
              Build on 
              <i style="font-size:25px;" class="fab fa-ethereum"></i>
              </p> -->
            </div>
          </div>

          <div   class="mt-sm-5 my-auto" style="" v-if="wallet">

            <center>
            
              

                 <h2 class="page-ath-heading mt-2 ">Log in <br>  <small>to your decentralized KYC sharing wallet</small>
                 </h2>
              
          

              <div class="mb-2 mt-2">
                <form @submit.prevent="handleSubmit">
                  <div class="col-md-6 col-lg-7 col-sm-6 col-xl-8">
                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Password
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        v-model="password"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.password.$error,
                        }"
                        type="password"
                      />
                      <small class="form-text text-muted"
                        >Enter Password to login in your wallet</small
                      >
                      <div
                        v-if="submitted && !$v.password.required"
                        class="invalid-feedback"
                      >
                      Password is required.
                      </div>
                    </div>
                    <button
                      style="background-color:#ffc925;color:white"
                      class="btn btn-block"
                    >
                      Log in
                    </button>
                  </div>
                </form>
              </div>
            </center>
          </div>
          <div class="mt-sm-3 my-auto"  v-else>
            <center class="mt-2">
            

              <div   class="" v-if="isImport == false && create == false">
            
                <button
                  @click="isImport = true"
                  class="btn rounded col-md-3 col-3   large my-3 mx-2 col-xs-6"
                  style="background-color:#ffc925;color:white;"
                >
                  Import
                </button>
                <br>
                <button
                  @click="create = true"
                  class="btn rounded col-md-3 col-3   large my-3 mx-2  col-xs-6"
                  style="background-color:#ffc925;color:white"
                >
                  Create a new wallet
                </button>
                <p class="mt-2 px-2 font-semibold">Login with your existing Tron Wallet or create a new Wallet</p>
                 <p class="mt-2 p-2 font-semibold">Open an account today</p>
              </div>

              <div  v-if="isImport" class="col-md-6 col-lg-7 col-sm-7 col-xl-8">
                <h4 style="margin-top:7%;" class="font-bold">
                  Import a wallet using
                </h4>
                <div data-aos="fade-up" class="input-item input-with-label mt-2">
                  <select
                    class="form-control  custom-select"
                    @change="setType"
                    :class="{ 'is-invalid': submitted && $v.type.$error }"
                    name="nationality"
                    v-model="type"
                    id="nationality"
                  >
                    <option style="my-4" value disabled selected
                      >Choose your option</option
                    >
                    <option
                      class="my-2 py-2"
                      style="margin-bottom:20px;padding:5%;"
                      :value="data"
                      v-for="(data, index) in list"
                      :key="index"
                      >{{ data }}
                    </option>

                    <!-- <option value="us">United State</option>
                          <option value="uk">United KingDom</option>
                          <option value="fr">France</option>
                          <option value="ch">China</option>
                          <option value="cr">Czech Republic</option>
                            <option value="cb">Colombia</option>-->
                  </select>
                  <div
                    v-if="submitted && !$v.type.required"
                    class="invalid-feedback"
                  >
                    Selection is required
                  </div>
                      <span
                 v-if='type==""'
                    @click.prevent="back"
                      class=" mx-auto my-3  btn"
                       style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                      Back
                    </span>
                </div>

             
                    

                <!-- .input-item -->
              </div>

              <div
              
              
                v-if="type == 'Private key'"
              >
              
                  <div data-aos="fade-up"   class="col-md-6 col-lg-7 col-sm-7 col-xl-8 ">
                      <form @submit.prevent="handleSubmit">
                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Private Key
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        v-model="pk"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.pk.$error }"
                        type="text"
                      />
                      <div
                        v-if="submitted && !$v.pk.requiredPk"
                        class="invalid-feedback"
                      >
                        Private key is required
                      </div>
                    </div>

                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Password
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        v-model="password"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.password.$error,
                        }"
                        type="password"
                      />
                      <small class="form-text text-muted"
                        >Create a new password for KYC.Crypto DeFi wallet</small
                      >
                      <div
                        v-if="submitted && !$v.password.required"
                        class="invalid-feedback"
                      >
                        Password should be at least 8 character long and it should contain at least one uppercase character, one lowercase character and one special character.
                      </div>
                    </div>

                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Confirm Password
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        v-model="cPassword"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.cPassword.$error,
                        }"
                        type="password"
                      />

                      <div
                        v-if="submitted && !$v.cPassword.required"
                        class="invalid-feedback"
                      >
                        confirm password should match password and can't be
                        empty
                      </div>
                    </div>
                     
                    <button
                    @click.prevent="handleSubmit"
                      class="btn  mx-auto my-3"
                      style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                   Submit
                    </button>

                     <span
                    @click.prevent="back"
                      class=" mx-auto my-3  btn"
                       style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                      Back
                    </span>
                    
                     </form>   
                     
                  </div>
                                  
                 
              </div>

              <div v-else-if="type == 'Keystore file'">
                <form @submit.prevent="handleSubmit">
                  <div data-aos="fade-up"  class="col-md-6 col-lg-7 col-sm-7 col-xl-8">
                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Select Keystore file
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        style="
    
                                        width: 100%;
                                        padding-bottom:15px;
                                        height: 50px;
                                        left:25%;
                                        overflow: hidden;
                                        -webkit-box-sizing: border-box;
                                        -moz-box-sizing: border-box;
                                        box-sizing: border-box;
                                        
                                      
                                        background-size: 60px 60px;"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.keyFile.$error,
                        }"
                        type="file"
                        accept=".json"
                        @change="readKeystoreJsonFile"
                      />

                      <div
                        v-if="submitted && !$v.keyFile.requireKey"
                        class="invalid-feedback"
                      >
                        Keystore file is required
                      </div>
                    </div>

                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Password
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        v-model="keystorePassword"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.keystorePassword.$error,
                        }"
                        type="password"
                      />
                      <small class="form-text text-muted"
                        >Password to unlock your wallet</small
                      >
                      <div
                        v-if="submitted && !$v.keystorePassword.required"
                        class="invalid-feedback"
                      >
                      Password is required.
                      </div>
                    </div>
                           <button
                    @click.prevent="handleSubmit"
                      class="btn  mx-auto my-3"
                      style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                   Submit
                    </button>

                     <span
                    @click.prevent="back"
                      class=" mx-auto my-3  btn"
                       style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                      Back
                    </span>
                    
                    
                  </div>
                </form>
              </div>
              <div v-if="type == 'Mnemonic phrase'">
                <form @submit.prevent="handleSubmit">
                  <div  data-aos="fade-up" class="col-md-6 col-lg-7 col-sm-7 col-xl-8">
                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Mnemonic phrase
                        <span class="text-danger">*</span>
                      </label>

                      <textarea
                        v-model="seed"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.seed.$error }"
                        type="text"
                      />
                      <small
                        style="font-size:15px;"
                        class="form-text text-muted font-semibold"
                        >Note: Enter mnemonic phrase with only one space in
                        between each word</small
                      >
                      <small
                        style="font-size:15px;"
                        class="form-text text-muted font-semibold"
                        >E.g: One Two Three</small
                      >
                      <div
                        v-if="submitted && !$v.seed.required"
                        class="invalid-feedback"
                      >
                        Mnemonic phrase is required
                      </div>
                    </div>

                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Password
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        v-model="password"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.password.$error,
                        }"
                        type="password"
                      />
                      <small class="form-text text-muted"
                        >Create a new password for KYC.Crypto DeFi wallet</small
                      >
                      <div
                        v-if="submitted && !$v.password.required"
                        class="invalid-feedback"
                      >
                        Password should be at least 8 character long and it should contain at least one uppercase character, one lowercase character and one special character.
                      </div>
                    </div>

                    <div class="input-item input-with-label form-group">
                      <label class="input-item-label">
                        Confirm Password
                        <span class="text-danger">*</span>
                      </label>

                      <input
                        v-model="cPassword"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && $v.cPassword.$error,
                        }"
                        type="password"
                      />

                      <div
                        v-if="submitted && !$v.cPassword.required"
                        class="invalid-feedback"
                      >
                        confirm password should match password and can't be
                        empty
                      </div>
                    </div>
                        <button
                    @click.prevent="handleSubmit"
                      class="btn  mx-auto my-3"
                      style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                   Submit
                    </button>

                     <span
                    @click.prevent="back"
                      class=" mx-auto my-3  btn"
                       style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                      Back
                    </span>
                    
                  </div>
                </form>
              </div>

              <div style="margin-top:7%;margin-bottom:5%;" v-else-if="create && step == 1">
                <form @submit.prevent="handleSubmit">
                  <div  data-aos="fade-up" class="col-md-6 col-lg-7 col-xl-8  col-sm-7 ">
                    <div
                      style="border:2px #ffc925 solid;border-radius:10px;"
                      class="py-3 px-4"
                    >
                      <h6>
                        <span
                          style="color:blue;background-color:#ffc925;border:0"
                          class="badge badge-info badge-lg mb-3 mt-2 round"
                          >Step {{ step }}</span
                        >
                      </h6>
                      <div class="input-item input-with-label form-group">
                        <label class="input-item-label">
                          Password
                          <span class="text-danger">*</span>
                        </label>

                        <input
                          v-model="password"
                          class="form-control"
                          :class="{
                            'is-invalid': submitted && $v.password.$error,
                          }"
                          type="password"
                        />
                        <small class="form-text text-muted"
                          >Create a new password for KYC.Crypto DeFi wallet</small
                        >
                        <div
                          v-if="submitted && !$v.password.required"
                          class="invalid-feedback"
                        >
                          Password should be at least 8 character long and it should contain at least one uppercase character, one lowercase character and one special character.
                        </div>
                      </div>

                      <div class="input-item input-with-label form-group">
                        <label class="input-item-label">
                          Confirm Password
                          <span class="text-danger">*</span>
                        </label>

                        <input
                          v-model="cPassword"
                          class="form-control"
                          :class="{
                            'is-invalid': submitted && $v.cPassword.$error,
                          }"
                          type="password"
                        />

                        <div
                          v-if="submitted && !$v.cPassword.required"
                          class="invalid-feedback"
                        >
                          confirm password should match password and can't be
                          empty
                        </div>
                      </div>
                      <button
                    @click.prevent="handleSubmit"
                      class="btn  mx-auto my-3"
                      style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                   Next
                    </button>

                     <span
                    @click.prevent="back"
                      class=" mx-auto my-3  btn"
                       style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                    >
                      Back
                    </span>
                    
                      
                    </div>
                  </div>
                </form>
               
              </div>

              <div   style="margin-top:7%;margin-bottom:5%;" v-else-if="create && step == 2">
                <form>
                  <div data-aos="fade-up" class="col-md-6 col-lg-7 col-sm-7 col-xl-8">
                    <div
                      style="border:2px #ffc925 solid;border-radius:10px;"
                      class="py-3 px-4"
                    >
                      <h6>
                        <span
                          style="color:blue;background-color:#ffc925;border:0"
                          class="badge badge-info badge-lg mt-2 mb-3 round"
                          >Step {{ step }}</span
                        >
                      </h6>
                      <div class="input-item input-with-label form-group">
                        <label class="input-item-label">
                          Note down mnemonic phrase
                        </label>

                        <div
                          style="word-break:break-word;text-align:justified;border:1px grey solid"
                          class="p-4  rounded mb-1"
                        >
                          <div style="font-size:20px;">{{ this.seed }}</div>

                          <!-- <span style="border:2px solid;bottom:25px;display:inline-block;border-radius:8px" class="mx-1 font-semibold border-primary my-2 p-2" v-for="(data,index) in showSeed" :key=index>{{data}}</span></div> -->
                        </div>
                        <small style="font-size:15px;" class="font-semibold"
                          >WARNING: Never disclose your backup phrase. Anyone
                          with this phrase can take your assets forever.</small
                        >
                      </div>
                      <button
                        @click.prevent="downloadSeed"
                        style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                        class="btn   my-3 mx-auto"
                        ><i class="btn-icon fa fa-download" /> Download
                        pharse</button
                      >
                      <button
                        
                          style="background-color:#ffc925;color:white;width:100%;border-radius:5px;"
                          class= "btn my-3 mx-auto"
                          @click.prevent="createWallet"
                        >
                          Next
                        </button
                      >
                    </div>
                  </div>
                </form>
              </div>

              <div style="margin-top:auto;margin-bottom:5%" v-else-if="create && step == 3">
                <form @submit.prevent="handleSubmit">
                  <div  data-aos="fade-up" class="col-md-7 col-lg-7 col-sm-7 col-xl-8 ">
                    <p style="font-size:17px" class="font-semibold">Save My Keystore File</p>

                    <img class="mt-1 mb-3" style="width:auto;height:300px" src="../assets/notes.jpg"/>
                    <div
                      style="border:2px #ffc925 solid;border-radius:10px;"
                      class="py-3 px-4 mt-2 "
                    >
                      <h6>
                        <span
                          style="color:blue;background-color:#ffc925;border:0"
                          class="badge badge-info badge-lg mb-3 mt-2 round"
                          >Step {{ step }}</span
                        >
                      </h6>
                      <div
                        style="border:2px lightgrey dashed ;padding:20px"
                        class="mt-4 rounded"
                      >
                      <center>
                        <span
                          style="background-color:lightgray;color:black;border:0"
                          @click.prevent="downloadFile"
                          class="btn mx-auto ml-0 px-3"
                          ><i class="fa fa-download" style="margin-right:10px;font-size:17px;margin-left:0" /> Download
                          Keystore file</span
                        >

                        <p class="mt-4 small">Note: This Keystore  only works on our KYC.Crypto DeFi platform , please don't use it on any other wallet.</p>
                      </center>
                      </div>
                      <button
                       
                        style="background-color:#ffc925;color:white"
                        class=" p-2 mt-4 btn  rounded large btn-block"
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </center>
          
  
          </div>
          
        <!-- <h4 style="text-align:center;position:relative;bottom:50px;" >build</h4> -->
        
        </div>
        
       
       


        <div
          style="background-color:#141F37"
          class="page-ath-gfx"
        >
          <div style="background-color:#141F37" class="">
            <img style="   position:static;
        
         
          background-size:cover;
          top:0;
      
          bottom:10;
          width:100vw;
          min-height:105vh;" src="../assets/anim.png"/>
          
            <!-- <video
              style="

          position:fixed;
          margin:0;
          padding:0;
          top:0;
          bottom:0;
          width:auto;
          min-height:100%;
	              "
              autoplay
             muted
              loop
            >
            <source src="https://drive.google.com/file/d/11RvFEBvTBEOq69gy3SrDx0mAiYWYpniy/preview" type="video/mp4">
            </video> -->
           
          </div>
        </div>
      </div>

      <!-- JavaScript (include all script here) -->
    </body>
  </div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";

import utils from '../utils/utils';

import {encrypt,decrypt} from '../utils/crypto';
export default {
  name: "Login",
  data() {
    return {
      wallet: undefined,
      showSeed: [],
      list: ["Keystore file", "Private key", "Mnemonic phrase"],
      type: "",
      pk: "",
      password: "",
      cPassword: "",
      submitted: false,
      keyFile: "",
      seed: "",
      isImport: false,
      create: false,
      step: 1,
      keystorePassword:"",
      web3: this.$store.state.web3,
    };
  },
  validations: {
    password: { 
     required(){
       let dec=false;
        if(this.type!=="Keystore file" && (this.create || this.isImport)){
          console.log('here')
            if(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(this.password)){
              dec=true;
            }
      } else if(this.type=='Keystore file'){
        dec=true;
      }
      else if(this.wallet){
        if(this.password!=""){
          dec=true
        }
      }
      return dec;

     }
      // required(){
     
    } ,
    keystorePassword: {
    
      required(){
        let dec=true;
        
      if(this.type=="Keystore file"){
        if(this.keystorePassword==""){
          console.log('hm')
          dec=false;
        } else{
          dec=true;
        }
      }
      return dec;
      }
    },
    cPassword: {
      required() {
        let dec = false;

        if (this.type == "Keystore file") {
          dec = true;
        } else if (
          (this.cPassword != this.password || this.cPassword == "") &&
          (this.isImport || this.create)
        ) {
          dec = false;
        } else {
          dec = true;
        }

        return dec;
      },
    },
    pk: {
      requiredPk() {
        let dec = true;
        if (
          this.type == "Private key" &&
          (this.pk == "" || this.pk == undefined)
        ) {
          dec = false;
        }
        return dec;
      },
    },
    type: {
      required() {
        if (this.isImport && this.type == "") {
          return false;
        } else {
          return true;
        }
      },
    },
    keyFile: {
      requireKey() {
        let dec = true;
        if (
          this.type == "Keystore file" &&
          (this.keyFile == "" || this.keyFile == undefined)
        ) {
          dec = false;
        }
        return dec;
      },
    },
    seed: {
      required() {
        let dec = true;
        if (
          this.type == "Mnemonic phrase" &&
          (this.seed == "" || this.seed == undefined)
        ) {
          dec = false;
        }
        return dec;
      },
    },
  },
  methods: {
    back(e){
      e.preventDefault();
        this.isImport=false;
        this.type="";
        this.create=false;
        this.$v.$reset();
    },
    async loginKeyStore() {
      
     

      try {
       // let wallet = this.keyFile;
        
        let dec=await decrypt(this.keystorePassword,this.keyFile)
             
                this.$store.state.loading = false;
                this.$toasted.global.my_app_success({
                  message: "Wallet imported successfully",
                });
                localStorage.wallet=this.keyFile
                localStorage.isSeed=true
                  this.$store.state.tronWeb.setAddress(dec.address)
                this.$cookies.set("address", dec.address, 0);
                this.$router.push("/");
      
      } catch (err) {
        this.$store.state.loading = false;
        this.$toasted.global.my_app_error({
          message: "Incorrect password entered or incorrect Keystore file selected",
        });
      }
    },
    async createWallet() {
     this.$store.state.loading = true;
      // let keystore = keyStore.keystore;
  try{
      
      //this.seed=await utils.generateMnemonic();
      console.log(this.seed);
      let validate=await utils.validateMnemonic(this.seed);
      console.log("validate:",validate);
     
     
      let account=await utils.getAccountAtIndex(this.seed);
      account.seed=this.seed;
      //console.log(this.cPassword)
      this.$cookies.set("address", account.address, 0);
    
      console.log(JSON.stringify(account));
     
      this.step++;
      this.$store.state.loading = false;
      let enc=await encrypt(this.cPassword,JSON.stringify(account));
      this.keyFile=enc;
      console.log(enc)
      // let dec=await decrypt(this.cPassword,enc);
      // console.log(dec);
      localStorage.wallet=enc;
      localStorage.isSeed=true
      
     
     
  }
      catch (err) {
        console.log(err)
        //err);
        this.$store.state.loading = false;
      }
     
    },
    downloadFile() {
      //   console.log(typeof this.keyFile);
      let exportObj = this.keyFile;
      let exportName = "KYC.Crypto wallet";
      var dataStr =
        "data:text/json;charset=utf-8," + encodeURIComponent(exportObj);
      var downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", exportName + ".json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },

    downloadSeed() {
      //   console.log(typeof this.keyFile);
      let exportObj = this.seed;
      let exportName = "Secret backup mnemonic phrase";
      var dataStr =
        "data:text/json;charset=utf-8," + encodeURIComponent(exportObj);
      var downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", exportName + ".txt");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },
    async loginPass() {
      
     
      if (localStorage.wallet && localStorage.isPk=='true') {
        
         
        try {
          this.$store.state.loading = true;
          let wallet=await decrypt(this.password,localStorage.wallet);
          console.log(wallet)
          //wallet=JSON.parse(wallet)
      this.$store.state.tronWeb.setAddress(wallet.address)

          await this.$cookies.set(
            "address",
            wallet.address,
            0
          );
            this.$toasted.global.my_app_success({
            message: "Logged in successfully"
          });
          this.$router.push("/");
        
        } catch (err) {
          console.log(err)
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "Please enter correct password to login",
          });
        }
        finally{
          this.$store.state.loading=false;
        }
      }
       else if (localStorage.wallet && localStorage.isSeed=='true') {
        
        try {
          this.$store.state.loading = true;
         
      let enc=await decrypt(this.password,localStorage.wallet);
      console.log(enc)
      // let dec=await decrypt(this.cPassword,enc);
      // console.log(dec);
      this.$store.state.tronWeb.setAddress(enc.address)
                 this.$cookies.set("address",enc.address , 0);
                 this.$toasted.global.my_app_success({
            message: "Logged in successfully"
          });
           // this.$store.state.loading = false;
                  this.$router.push("/");
     
        
       
                  
               
        } catch (err) {
              this.$store.state.loading = false;
                  this.$toasted.global.my_app_error({
                    message: "Please enter correct password to login",
                  });
        }
        finally{
           this.$store.state.loading = false;
        }
      }
    },
    async loginpk() {
      try {
        this.$store.state.loading = true;

        let account;
        let acc;
        account=await utils.validatePrivateKey(this.pk);
        if(account==false) throw Error('Please enter correct private key')
        account=await this.$store.state.tronWeb.address.fromPrivateKey(this.pk);
        console.log(account);
        this.$store.state.loading = false;
        
        this.$store.state.tronWeb.setAddress(account)
        let address={
          address:account,
          privateKey:this.pk
        }
         let enc=await encrypt(this.cPassword,JSON.stringify(address));
        
        localStorage.wallet=enc
         localStorage.isPk=true
         this.$cookies.set("address", account, 0);
        this.$toasted.global.my_app_success({
                  message: "Wallet imported successfully",
                });
        this.$router.push("/");
      } catch (err) {
        this.$store.state.loading = false;
        this.$toasted.global.my_app_error({
          message: "Please enter correct private key",
        });
      }
    },
    async loginSeed() {
      try {
        //notice jealous lemon pole range orient protect easy senior equip hurt move

        //   let ethers=require('ethers');
        //   let wallet=ethers.Wallet.fromMnemonic(this.seed);
        //   console.log(wallet.privateKey);
         //  // this.pk=wallet.privateKey.toString();
    this.$store.state.loading=true;
      let validate=await utils.validateMnemonic(this.seed);
      console.log("validate:",validate);

        if(validate){
          
     
     
      let account=await utils.getAccountAtIndex(this.seed);
      account.seed=this.seed;
      //console.log(this.cPassword)
      this.$cookies.set("address", account.address, 0);
    
      console.log(JSON.stringify(account));
      localStorage.wallet=account
     
      this.$store.state.loading = false;
      let enc=await encrypt(this.cPassword,JSON.stringify(account));
      console.log(enc)
        this.$store.state.tronWeb.setAddress(account.address)
      // let dec=await decrypt(this.cPassword,enc);
      // console.log(dec);
      localStorage.wallet=enc;
      localStorage.isSeed=true;
       this.$toasted.global.my_app_success({
                  message: "Wallet imported successfully",
                });
      this.$router.push('/');
      
     
        }
        else {
          this.$store.state.loading = false;
          this.$toasted.global.my_app_error({
            message: "Please enter valid mnemonic phrase",
          });
        }
      } catch (err) {
        console.log(err);
        //err)
      }
     
    },
    setType() {
      this.keystore = "";
      this.pk = "";
      this.password = "";
      this.cPassword = "";
    },
    readKeystoreJsonFile(e) {
      var files = e.target.files;

      if (files.length > 1) {
        return;
      }

      var reader = new FileReader();

      reader.onload = function(e) {
        this.keyFile = e.target.result;
      }.bind(this);

      reader.onerror = function(e) {}.bind(this);

      reader.readAsText(files[0]);
    },
    async handleSubmit(e) {
      this.submitted = true;
    console.log(this.keystorePassword)
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
       
         console.log("invalid");
        return;
      }
      if (this.isImport) {
        if (this.type == "Private key") {
          await this.loginpk();
        } else if (this.type == "Keystore file") {
          await this.loginKeyStore();
        } else if (this.type == "Mnemonic phrase") {
          await this.loginSeed();
        }
      } else if (this.create) {
        if (this.step < 2) {
          this.step++;
          if (this.step == 2) {
            

            this.seed = await utils.generateMnemonic();
            this.showSeed = this.seed.split(/\s+/);
            //  await this.createWallet();
          }
          
        } else if(this.step>2) {
          this.$router.push('/')
          //'Done');
        }
      } else if (this.wallet) {
        await this.loginPass();
      }
    },
  },

  created() {
    this.$store.state.loading = false;
    if (localStorage.wallet) {
      this.wallet = localStorage.wallet;
    } else if (localStorage.wallet_web3) {
      this.wallet = localStorage.wallet_web3;
    }
    this.$cookies.remove('address')
  },
};
</script>

<style scoped>
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";
</style>
